<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="books-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">小説の追加</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul class="list-group">
                        <a href="#" class="list-group-item list-group-item-action"
                            v-for="b in books" :key="b.id"
                            @click="add(b.id)">
                            <i class="fas fa-plus"></i>
                            {{b.title}}
                            <span class="badge badge-secondary" v-if="!b.is_long">短編</span>
                        </a>
                    </ul>
                    <div v-if="!books.length">
                        シリーズに追加できる小説がありません。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        series_id: {
            required: true,
        },
    },
    data() {
        return {
            books: {},
            book_id: null,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/series/books/get").then(res => {
                this.books = res.data;
            }).catch(err => {
                alert.err(err.response);
            });
        },
        add(id) {
            axios.post("/mypage/series/books/add", {
                series_id: this.series_id,
                book_id: id
            }).then(res => {
                alert.msg(res.data);
                this.$emit("saved");
                this.books = {};
                $("#books-modal").modal("hide");
            }).catch(err => {
                alert.err(err.response);
            });
        }
    },
    mounted() {
        $("#books-modal").on("show.bs.modal", (e) => {
            this.load();
        });
        $("#books-modal").on("hide.bs.modal", (e) => {
            this.$emit("closed");
        });
    }
}
</script>

